module.exports = __webpack_public_path__ + "static/bgHeroMina-222cb91649528fa70dc3bff4a7c34469.jpg";